/**
 * @param {string} nftName foramt: NFT_NAME#TOKEN_ID | Example: MyNft#123
 */
const generateSharePostUrl = (nftName: string) => `https://twitter.com/intent/tweet?text=I'm planning to participate in the Eternal Vikings mint ceremony by sacrificing ${nftName.replace('#', '_')}. What will you sacrifice?&via=Eternal_Vikings&hashtags=Sacrifice2Mint`
export default generateSharePostUrl;